module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    ref: "app",
    class: {
      'is-waiting': _vm.isWaiting
    },
    attrs: {
      "id": "app"
    }
  }, [_vm._l((_vm.loggedInUserRealms), function(realm) {
    return _c('div', [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": realm.params.style.logo
      }
    })])
  }), _vm._v(" "), (_vm.isToolbarVisible) ? _c('div', [_c('v-toolbar', {
    attrs: {
      "color": _vm.mainColor,
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_c('h3', {
    on: {
      "click": function($event) {
        _vm.home()
      }
    }
  }, [_vm._v("\n               " + _vm._s(_vm.title) + "\n            ")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.platform === 'shdl' ? "Université de Toulouse - INPT - ENSEEIHT - JCB" : "Hôpitaux de Toulouse") + "\n         ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n            v1.13.2\n         ")]), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("\n               " + _vm._s(_vm.loggedInUserDescription) + "\n            ")]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Déconnexion")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isAuthenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("\n            Connexion\n         ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isAuthenticated) ? _c('v-tabs', {
    attrs: {
      "icons-and-text": "",
      "centered": "",
      "dark": "",
      "color": _vm.mainColor
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _vm._l((_vm.authorizedActivities), function(activity) {
    return (activity.tab) ? _c('v-tab', {
      key: activity.uid,
      attrs: {
        "to": {
          path: activity.url
        },
        "router": ""
      }
    }, [_vm._v("\n            " + _vm._s(activity.tab.name) + "\n            "), _c('v-badge', {
      attrs: {
        "right": "",
        "color": "brown"
      }
    }, [(activity.uid === 'messages' && _vm.unreadMessageCount > 0) ? _c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(_vm.unreadMessageCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(activity.tab.icon))])], 1)], 1) : _vm._e()
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-content', {
    class: {
      'global--background-shrink': _vm.shrink
    },
    attrs: {
      "ccccccclass": "global--background"
    }
  }, [_c('router-view', {
    on: {
      "onLogin": _vm.onLogin,
      "onLogout": _vm.onLogout
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.invitationDialog),
      callback: function($$v) {
        _vm.invitationDialog = $$v
      },
      expression: "invitationDialog"
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Envoi d'une invitation")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": _vm.emailRules,
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": _vm.mainColor,
      "flat": "",
      "disabled": !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.invitationDialog = false;
        _vm.inviteCoach()
      }
    }
  }, [_vm._v("Envoyer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": _vm.mainColor,
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.invitationDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarOptions.timeout,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "color": _vm.snackbarOptions.color,
      "multi-line": true,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarOptions.text) + "\n   ")]), _vm._v(" "), _c('confirm-dialog')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1194
// module chunks = 1